import type { ReactNode } from "react";
import { cn } from "../lib/cn";

export function Card({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <div
      className={cn(
        "rounded-[var(--radius-card)] border border-[var(--border-subtle)] bg-[var(--surface-card)] shadow-[var(--shadow-raised)]",
        className,
      )}
    >
      {children}
    </div>
  );
}

export function CardHeader({ title, action }: { title: string; action?: ReactNode }) {
  return (
    <div className="flex items-center justify-between gap-2 border-b border-[var(--border-subtle)] px-4 py-3">
      <h2 className="text-sm font-semibold text-[var(--text-primary)]">{title}</h2>
      {action}
    </div>
  );
}

export function CardBody({ className, children }: { className?: string; children: ReactNode }) {
  return <div className={cn("p-4", className)}>{children}</div>;
}

export function Stat({ label, value, hint }: { label: string; value: ReactNode; hint?: string }) {
  return (
    <Card className="p-3 sm:p-4">
      <div className="text-2xs font-medium uppercase tracking-wider text-[var(--text-muted)]">
        {label}
      </div>
      <div className="numeric mt-1 text-xl font-semibold text-[var(--text-primary)] sm:text-2xl">
        {value}
      </div>
      {hint && <div className="mt-0.5 text-xs text-[var(--text-secondary)]">{hint}</div>}
    </Card>
  );
}

export function KeyValue({ items }: { items: Array<{ label: string; value: ReactNode }> }) {
  return (
    <dl className="grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2">
      {items.map((item) => (
        <div key={item.label} className="min-w-0">
          <dt className="text-2xs font-medium uppercase tracking-wider text-[var(--text-muted)]">
            {item.label}
          </dt>
          <dd className="mt-0.5 break-words text-sm text-[var(--text-primary)]">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
